// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Container = require("../../common/Components/Container.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardBodyRelay = require("./PropertyWizardBodyRelay.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
let PropertyWizardRelay_serverDraft_graphql = require("../../../__generated__/PropertyWizardRelay_serverDraft_graphql.bs.js");

let convertFragment = PropertyWizardRelay_serverDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelay_serverDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelay_serverDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelay_serverDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelay_serverDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay(props) {
  let formReady = PropertyWizardFormRelay.useInitForm(props.draftData, props.draftDbId, undefined);
  if (formReady) {
    return JsxRuntime.jsx(PropertyWizardBodyRelay.make, {});
  } else {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Container.make, {
        children: JsxRuntime.jsx(PropertyWizardFormRelay__Elements.LoadingSpinner.make, {})
      }),
      className: "flex-1"
    });
  }
}

let FormElements;

let make = PropertyWizardRelay;

exports.FormElements = FormElements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Container Not a pure module */
